import React from "react";
import { api } from "../../../services/api";
import { ShowToast } from "../../../services/toast";
import { Button } from "../../../components/Button";
import { ResetPasswordSuccess } from "../../auth/components/ResetPasswordSuccess";
import { Password } from "../../auth/components/Password";
import { PopupModal } from "../../../components/PopupModal";
import { ReactComponent as Close } from "../../../assets/icons/x.svg?react";
import { USER_TYPES } from "../../../constant";
import passwordValidation from "../../../services/utils";

export function ChangePassword({
  onClose,
  user,
}: {
  onClose: () => void;
  user: any;
}) {
  const [disabled, setDisabled] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [errors, setErrors] = React.useState({} as any);
  const formRef = React.useRef<HTMLFormElement>(null);

  const handleSubmit = async () => {
    // get the form data
    const formData = new FormData(formRef.current as HTMLFormElement);
    // convert the form data to an object
    const data = Object.fromEntries(formData);
    // log the results
    try {
      setLoading(true);
      const response = await api.changePassword(user.id, {
        oldPassword: data.oldPassword,
        newPassword: data.password,
      });
      if ([200, 201].includes(response.status)) {
        ShowToast({
          type: "success",
          message: "Password Changed!",
        });
        setSuccess(true);
      }
      setLoading(false);
    } catch (error: any) {
      ShowToast({
        type: "error",
        message: error.response.data.message || "There is some problem to reset password. Please try again",
      });
      setLoading(false);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLFormElement>) => {
    const formData = new FormData(e.currentTarget);
    const data = Object.fromEntries(formData);
    const newErrors = {} as any;
    let disabled = false
    if (data.oldPassword.toString() === data.password.toString()) {
      if (data.oldPassword.toString() !== '' && data.password.toString() !== '') {
        newErrors.password = "New password should be different from old password";
      }
      disabled = true
    }
    if (!passwordValidation(data.password.toString())) {
      if (data.password !== '') {
        newErrors.password = "Password should contain at least 8 characters, 1 letter, 1 number and 1 special character";
      }
      disabled = true
    }
    if (data.password !== data.confirmPassword) {
      if (data.confirmPassword !== '') {
        newErrors.confirmPassword = "Password does not match";
      }
      disabled = true
    }
    if (Object.keys(newErrors).length === 0) {
      setErrors({});
    } else {
      setErrors(newErrors);
    }
    setDisabled(disabled)
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <PopupModal
      onClose={handleClose}
      contentClassName="p-8 !pt-3 z-[2] bg-white rounded-2xl flex-col justify-start items-center gap-6 flex mx-auto w-[98%] md:w-[442px] max-w-[442px]"
    >
      <div className="flex flex-col w-full">
        <div className="flex justify-center items-center w-full">
          {success ? (
            <ResetPasswordSuccess userType={USER_TYPES.ADMIN} />
          ) : (
            <form
              className="flex flex-col w-full"
              onChange={handleChange}
              ref={formRef}
            >
              <div className="rounded-lg flex flex-col">
                <div className="flex justify-between items-center">
                  <div className="text-black text-[28px] font-bold leading-loose">
                    Change Password
                  </div>
                  {user?.loginState !== "ChangePassword" && (
                    <button type="button" onClick={handleClose}>
                      <Close className="w-6 h-6 relative" />
                    </button>
                  )}
                </div>
                <span className="text-black/80 text-sm font-normal leading-normal ">
                  {user?.loginState === "ChangePassword" ?
                    "To get started, please first create your own password" : "Change your password below."
                    }
                </span>
                <div className="my-6 flex flex-col gap-5">
                  <div className="flex flex-col gap-1.5">
                    <span className="text-black text-xs font-medium">
                      Old Password
                    </span>
                    <Password
                      placeholder="Enter old password"
                      className="!p-[14px]"
                      name="oldPassword"
                    />
                    {errors.password && (
                      <div className="text-red-500 text-xs font-medium">
                        {errors.oldPassword}
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <span className="text-black text-xs font-medium">
                      New Password
                    </span>
                    <Password
                      placeholder="Create a new password"
                      className="!p-[14px]"
                      name="password"
                    />
                    {errors.password && (
                      <div className="text-red-500 text-xs font-medium">
                        {errors.password}
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <span className="text-black text-xs font-medium">
                      Confirm Password
                    </span>
                    <Password
                      type="password"
                      placeholder="Re-enter the password"
                      className="!p-[14px]"
                      name="confirmPassword"
                    />

                    {errors.confirmPassword && (
                      <div className="text-red-500 text-xs font-medium">
                        {errors.confirmPassword}
                      </div>
                    )}
                  </div>
                </div>
                <Button
                  disabled={disabled || loading}
                  loading={loading}
                  className="!rounded-full w-full"
                  variant="primary"
                  onClick={handleSubmit}
                >
                  Reset
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
    </PopupModal>
  );
}
